

// represent status of a scout path or path test, or path test point
export namespace activity_status {
    export enum Id {
        NOT_STARTED = 1,
        IN_PROGRESS = 2,
        COMPLETE = 3,
        FIELD_COMPLETE = 4,
        REVIEW_COMPLETE = 5,
        NOT_USING = 6,
        ARCHIVED = 7
    }
    
    export type Name = "not started"|"in progress"|"complete"
        |"field complete"|"review complete"|"not using"|"archived" 

    export let Names = new class {
        readonly NOT_STARTED: Name = "not started"
        readonly IN_PROGRESS: Name = "in progress"
        readonly COMPLETE: Name = "complete"
        readonly FIELD_COMPLETE: Name = "field complete"
        readonly REVIEW_COMPLETE: Name = "review complete"
        readonly NOT_USING: Name = "not using"
        readonly ARCHIVED: Name = "archived"

        byId = (id:Id) => this[id] || `status(${id})`
    }

    // map database id to string and vice versa
    Names[Id.NOT_STARTED] = Names.NOT_STARTED
    Names[Id.IN_PROGRESS] = Names.IN_PROGRESS
    Names[Id.COMPLETE] = Names.COMPLETE
    Names[Id.FIELD_COMPLETE] = Names.FIELD_COMPLETE
    Names[Id.REVIEW_COMPLETE] = Names.REVIEW_COMPLETE
    Names[Id.NOT_USING] = Names.NOT_USING
    Names[Id.ARCHIVED] = Names.ARCHIVED

    Id[Names.NOT_STARTED] = Id.NOT_STARTED
    Id[Names.IN_PROGRESS] = Id.IN_PROGRESS
    Id[Names.COMPLETE] = Id.COMPLETE
    Id[Names.FIELD_COMPLETE] = Id.FIELD_COMPLETE
    Id[Names.REVIEW_COMPLETE] = Id.REVIEW_COMPLETE
    Id[Names.NOT_USING] = Id.NOT_USING
    Id[Names.ARCHIVED] = Id.ARCHIVED
}

export type TaskStatusId = 'none'|'scheduleRequested'|'scheduled'|'inProgress'|'complete'|'approved'|'archived'

export class TaskStatus {

    id?: TaskStatusId
    timestamp: string
    userId: string

    static Ids = ['scheduleRequested','scheduled','inProgress','complete','approved','archived']

    static getLatestId( statusGroup : { [id:string]: TaskStatus } ) : TaskStatusId {
        if ( !statusGroup ) {
            return null
        }
        const ids = Object.keys(statusGroup)
        return ids.reduce((latestId, id) => 
            new Date(statusGroup[id]?.timestamp) > new Date(statusGroup[latestId]?.timestamp) ? id : latestId, ids[0]) as TaskStatusId
    }

    static getStatusName(statusId: TaskStatusId) {
        switch (statusId) {
            case 'scheduleRequested': return "Schedule Requested"
            case 'scheduled': return "Scheduled"
            case 'inProgress': return "In Progress"
            case 'complete': return "Complete"
            case 'approved': return "Approved"
            case 'archived': return "Archived"
            case 'none': return "None"
            default: return statusId
        }
    }

    static uiLockHandler(statusId: number, isAdmin: boolean) {
        if (isAdmin) {
            switch (statusId) {
                case activity_status.Id.NOT_STARTED:
                case activity_status.Id.IN_PROGRESS:
                case activity_status.Id.FIELD_COMPLETE:
                    return false;
                case activity_status.Id.COMPLETE:
                case activity_status.Id.REVIEW_COMPLETE:
                case activity_status.Id.NOT_USING:
                    return true;
            }
        } else {
            switch (statusId) {
                case activity_status.Id.NOT_STARTED:
                case activity_status.Id.IN_PROGRESS:
                    return false;
                case activity_status.Id.COMPLETE:
                case activity_status.Id.FIELD_COMPLETE:
                case activity_status.Id.REVIEW_COMPLETE:
                case activity_status.Id.NOT_USING:
                    return true;
            }
        }
    }

    static statusLockHandler(statusId: number, isAdmin: boolean) {
        if (isAdmin) {
            switch (statusId) {
                case activity_status.Id.NOT_STARTED:
                case activity_status.Id.IN_PROGRESS:
                case activity_status.Id.COMPLETE:
                case activity_status.Id.FIELD_COMPLETE:
                case activity_status.Id.REVIEW_COMPLETE:
                case activity_status.Id.NOT_USING:
                    return false;
            }
        } else {
            switch (statusId) {
                case activity_status.Id.NOT_STARTED:
                case activity_status.Id.IN_PROGRESS:
                case activity_status.Id.FIELD_COMPLETE:
                    return false;
                case activity_status.Id.COMPLETE:
                case activity_status.Id.REVIEW_COMPLETE:
                case activity_status.Id.NOT_USING:
                    return true;
            }
        }
    }
}

